import React from "react";
import feature1 from "../assets/images/fea1.png";
import feature2 from "../assets/images/fea2.png";
import feature3 from "../assets/images/fea3.png";
import feature4 from "../assets/images/fea4.png";

const features = [
  {
    title: "Workout & Fitness Planning",
    description:
      "Over 150+ workouts custom for your fitness level: Beginner, Intermediate or Advanced.",
    imgSrc: feature1,
  },
  {
    title: "Fitness Motivation",
    description:
      "Track your body transformation. Track and log your weight with the weight tracker. Compare side-by-side photos of yourself.",
    imgSrc: feature2,
  },
  {
    title: "Health Data",
    description: "Monitor Calories Burnt, Steps Count, and Heart Rates.",
    imgSrc: feature3,
  },
  {
    title: "Reminders",
    description: "Water Reminder, Work out Reminder, Medicine Reminder",
    imgSrc: feature4,
  },
];

const Features = () => {
  return (
    <div className="px-8 lg:px-32 xl:px-52">
      <h2 className="text-center text-2xl lg:text-3xl font-bold mb-5 mt-14">
        App Features
      </h2>
      <div className="container mx-auto px-5 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:grid-cols-2">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg p-6 border hover:shadow-[#f16c7d]  transition-shadow duration-300"
            >
              <div className="flex justify-center mb-6">
                <img
                  src={feature.imgSrc}
                  alt={feature.title}
                  height={150}
                  className="object-contain max-h-[200px] features-img"
                />
              </div>
              <h3 className="text-[20px] font-semibold text-center mb-4 text-[#0d0d0d]">
                {feature.title}
              </h3>
              <p
                className="text-[#222222] text-center text-[14px]"
                dangerouslySetInnerHTML={{ __html: feature.description }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
